import axios from 'axios';

export const getAllAlloggiatiAccount = async () => {
    const url = `/api/v1/user_profile/bms/alloggiati_accounts`;
    const res = await axios.get(url);
    return res.data;
};

export const createAlloggiatiAccount = async (data) => {
    const url = `/api/v1/user_profile/bms/alloggiati_accounts`;
    const res = await axios.post(url, data);
    return res.data;
};

export const updateAlloggiatiAccount = async (id, data) => {
    const url = `/api/v1/user_profile/bms/alloggiati_accounts/${id}`;
    const res = await axios.patch(url, data);
    return res.data;
};

export const deleteAlloggiatiAccount = async (id) => {
    const url = `/api/v1/user_profile/bms/alloggiati_accounts/${id}`;
    const res = await axios.delete(url);
    return res.data;
};